module.exports = __webpack_public_path__ + "static/media/richard.fad231ed.png";